interface LogoProps {
  variant?: "light" | "dark";
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Logotipo oficial da Ocean — emblema circular com acabamento dourado.
 */
const LOGO_IMAGE_URL =
  "https://static.readdy.ai/image/65821e378a79f8aedcd94a859d1c517b/2e9d3af16b5d4abd91e2361b9e60e04b.png";

const sizeMap: Record<NonNullable<LogoProps["size"]>, string> = {
  sm: "h-9 w-9",
  md: "h-11 w-11",
  lg: "h-20 w-20 md:h-24 md:w-24",
};

export default function Logo({ size = "md", className = "" }: LogoProps) {
  return (
    <img
      src={LOGO_IMAGE_URL}
      alt="OCEAN Companhia de Comércio"
      title="OCEAN Companhia de Comércio"
      className={`object-contain ${sizeMap[size]} ${className}`}
    />
  );
}